import React, {
  Suspense, lazy, useEffect, useMemo, useState,
} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import KbRegionCompare from '../../components/KbRegionCompare';
import './ComparePage.css';

const RankingCompareModal = lazy(() => import('../../components/ranking/RankingCompareModalV2'));
const KBDataPage = lazy(() => import('../kb/KBDataPage'));

function ComparePage() {
  const location = useLocation();
  const navigate = useNavigate();

  const activeTabFromQuery = useMemo(() => {
    const query = new URLSearchParams(location.search);
    const tab = query.get('tab');
    if (tab === 'kbtable') return 'kbtable';
    return 'kb';
  }, [location.search]);

  const [activeTab, setActiveTab] = useState(activeTabFromQuery);

  useEffect(() => {
    setActiveTab(activeTabFromQuery);
  }, [activeTabFromQuery]);

  const compareTargets = useMemo(() => {
    const query = new URLSearchParams(location.search);
    const key = query.get('key');
    if (!key) return [];

    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed?.targets) ? parsed.targets : [];
    } catch (error) {
      console.error('비교 탭 데이터 파싱 실패:', error);
      return [];
    }
  }, [location.search]);

  const handleTabChange = (nextTab) => {
    setActiveTab(nextTab);
    const query = new URLSearchParams(location.search);
    query.set('tab', nextTab);
    if (nextTab !== 'complex' && nextTab !== 'kbtable') query.delete('key');
    navigate(`/compare?${query.toString()}`, { replace: true });
  };

  return (
    <div className="compare-page">
      <div className="compare-container">
        <div className="compare-tabs">
          <button
            className={`compare-tab ${activeTab === 'kb' ? 'active' : ''}`}
            onClick={() => handleTabChange('kb')}
          >
            지수비교
          </button>
          <button
            className={`compare-tab ${activeTab === 'kbtable' ? 'active' : ''}`}
            onClick={() => handleTabChange('kbtable')}
          >
            KB지수-표
          </button>
        </div>

        <div className="compare-content">
          {activeTab === 'kb' && <KbRegionCompare />}
          {activeTab === 'kbtable' && (
            <Suspense fallback={<div className="coming-soon"><p>KB지수-표를 불러오는 중입니다...</p></div>}>
              <KBDataPage />
            </Suspense>
          )}
          {activeTab === 'complex' && (
            <div className="compare-complex-panel">
              <Suspense fallback={<div className="coming-soon"><p>단지비교 화면을 준비 중입니다.</p></div>}>
                <RankingCompareModal targets={compareTargets} embedded />
              </Suspense>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ComparePage;
